// Add flags you want to use on the project

export const flagsAXP = [
  'flagAxpEmailBuilderComponentsRedesign',
  'flagAxpAdvancedSearch',
  'flagBuilderLazyLoadSections',
  'flagBuilderPageGlobalStorage',
  'flagBuilderRemoveColumnBackground',
  'flagBuilderUploadDownloadZip',
  'flagBuilderUploadVideo',
  'flagBuilderWeightLimitation',
  'flagAxpJimo',
] as const;

export const flagsIM = [
  'flagImEmojiPicker',
  'flagImCustomEmojiReactions',
] as const;

export default [
  ...flagsAXP,
  ...flagsIM,
  'flagActivateFrontMonitoringDatadog',
  'flagAxpBrandingMobileHeaderLogoToGlobalStorage',
  'flagAxpCampaignsCkDeprecation',
  'flagAxpBrandingFaviconToGlobalStorage',
  'flagAxpEngagementScoringImprovements',
  'flagAxpBrandingWebsiteFooterLogoToGlobalStorage',
  'flagAxpUserListRevampWave1',
  'flagBraintree3DSecureSca',
  'flagCurrentSessionContext',
  'flagDsIsolationNewsDetailPage',
  'flagEvAblyInactivityTracker',
  'flagEvBlockContentUploadCkEditor',
  'flagEvEventsBoRevamp',
  'flagEvGsMembershipLogo',
  'flagEvImproveSoldOutEventsFo',
  'flagEvMembershipFoPagination',
  'flagEvMentoringAdminMatch',
  'flagEvMessagingReactQuery',
  'flagEvNewEventFoCard',
  'flagEvNewsRevamp',
  'flagEvOrderSummaryDsEvents',
  'flagEvOrderSummaryDsMemberships',
  'flagEvPaymentPageDonations',
  'flagEvPaymentPageEvents',
  'flagEvPaymentPageMemberships',
  'flagEvPaymentsMovePromocode',
  'flagEvStripeCobrandedCards',
  'flagEvStripeDirectChargeForAllCC',
  'flagEvSuperAdminReadOnly',
  'flagEvTinyMce',
  'flagEvTinyMceOnlineAlerts',
  'flagEvTinyMceOrganizations',
  'flagEvUserPicturesToGlobalStorage',
  'flagEvVirusScanning',
  'flagGoogleMapsComponent',
  'flagHivehackNotifyPeople',
  'flagMobileAppsBoOptionalAndroidServiceAccountJson',
  'flagProfileCustomHeader',
  'flagRequestUserAccountDeletion',
  'flagSuEmailSecurity',
  'flagSuNotifSignin',
  'flagUeMobileCaretFooter',
  'flagUeNewOutdatedBrowserDetection',
  'flagUeSearchDeactivateGlobal',
  'flagUjAblyInternalNotifications',
  'flagUjAiContentRecommendation',
  'flagUjAiContentRecommendationReport',
  'flagUjAnchoringComments',
  'flagUjbBiggerBadgeSize',
  'flagUjbGroupHeaderRedesign',
  'flagUjbLfPagination',
  'flagUjNotificationsNotifyImprovement',
  'flagUjSearchLocationAnonymous',
  'flagUseWhitelabelCustomCertificate',
] as const;
